import { FluidLayout } from './fluid-layout';
import { MobileDesktopAlert } from './mobile-desktop-alert';

export function AppShell() {
  return (
    <>
      <FluidLayout />
      <MobileDesktopAlert />
    </>
  );
}
